import { createSlice } from "@reduxjs/toolkit";

// store
const initialState = {
    history: {},
};

export const historyState = createSlice({
    name: "historyState",
    initialState,
    reducers: {
        updateHistoryState: (state, action) => {
            state.history = action.payload;
        },
        removeHistoryState: (state) => {
            state.history = {};
        }
    }
})

export const { updateHistoryState, removeHistoryState } = historyState.actions;
export const getHistoryState = (state) => state.historyState.history;

export default historyState.reducer;